<template>
  <div>
    <div class="closeSurvey mb-2"
         @click="closeSurvey">
      <font-awesome-icon :icon="['fal', 'times-circle']"></font-awesome-icon>
      <slot>
        <span class="px-1">
          Close Survey
        </span>
      </slot>
    </div>
  </div>
</template>
<script>
import { INSTANCE_TYPE } from "~/Components/constants";
import {
  setInstanceAsCompleted as setThreeSixtyInstanceAsCompleted,
  setInstanceAsInactive as setThreeSixtyInstanceAsInactive,
} from "~/Scripts/resources/threeSixtyResource";
import {
  setInstanceAsCompleted as setEngageInstanceAsCompleted,
  setInstanceAsInactive as setEngageInstanceAsInactive,
} from "~/Scripts/resources/engageResource";
import {
  setInstanceAsCompleted as setTeamInstanceAsCompleted,
  setInstanceAsInactive as setTeamInstanceAsInactive,
} from "~/Scripts/resources/teamResource";

export default {
  name: "CloseSurvey",
  props: {
    instanceType: {
      type: String,
      required: true,
      validator: val => [
        INSTANCE_TYPE.THREE_SIXTY,
        INSTANCE_TYPE.PERSONA,
        INSTANCE_TYPE.STYLE,
        INSTANCE_TYPE.SURVEY,
        INSTANCE_TYPE.ENGAGE,
        INSTANCE_TYPE.TEAM,
      ].includes( val.toUpperCase() ),
    },
    instanceId: {
      type: String,
      required: true,
    },
    areReviewersFulfilled: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  computed: {
    setInstanceAsCompleted () {
      switch ( this.instanceType ) {
        case INSTANCE_TYPE.ENGAGE: {
          return setEngageInstanceAsCompleted;
        }
        case INSTANCE_TYPE.THREE_SIXTY: {
          return setThreeSixtyInstanceAsCompleted;
        }
        case INSTANCE_TYPE.TEAM: {
          return setTeamInstanceAsCompleted;
        }
        default: {
          throw new Error( "setInstanceAsCompleted not defined" );
        }
      }
    },
    setInstanceAsInactive () {
      switch ( this.instanceType ) {
        case INSTANCE_TYPE.ENGAGE: {
          return setEngageInstanceAsInactive;
        }
        case INSTANCE_TYPE.THREE_SIXTY: {
          return setThreeSixtyInstanceAsInactive;
        }
        case INSTANCE_TYPE.TEAM: {
          return setTeamInstanceAsInactive;
        }
        default: {
          throw new Error( "setInstanceAsInactive not defined" );
        }
      }
    },
    handleSurveyClosure () {
      return this.areReviewersFulfilled ? this.setInstanceAsCompleted : this.setInstanceAsInactive;
    },
  },
  methods: {
    closeSurvey () {
      const confimrationMessage = this.$createElement( "div", {
        domProps: {
          innerHTML: `You are about to close this survey early. 
          <br/>
          <br/>
          <i>Any reviewers who have not completed the survey will no longer have access.</i>
          <br/>
          <br/>
          Would you like to continue?`,
        },
      } );

      this.$bvModal
        .msgBoxConfirm( [confimrationMessage], {
          title: "Please Confirm",
          size: "md",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Yes",
          cancelTitle: "No",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        } )
        .then( async value => {
          if ( value ) {
            try {
              await this.handleSurveyClosure( { instanceId: this.instanceId } );
              window.location.reload();
            } catch ( ex ) {
              this.$bvToast.toast( "Please, try again or contact us.", {
                title: "Unable to close survey.",
                variant: "danger",
                solid: true,
              } );
            }
          }
        } )
        .catch( err => {
          console.error( err );
        } );
    },
  },
};
</script>
<style scoped lang="less">
@import "../../../Styles/utils/index.less";

.closeSurvey {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: @blue;

  &:hover {
    color: #dc143c;
  }
}
</style>
